<template>
  <div class="timer-text">
    <div v-if="leftSecsBegin > 0" class="timer-text__txt">距离开放购买:
      <timer-num :seconds="leftSecsBegin" />
    </div>
    <div v-else-if="leftSecsEnd > 0" class="timer-text__txt">已开放购买,离结束:
      <timer-num :seconds="leftSecsEnd" />
    </div>
    <div v-else class="timer-text__txt">本次预售活动已结束！</div>
  </div>
</template>

<script>
  import {
    mapGetters
  } from 'vuex';

  export default {
    computed: {
      ...mapGetters(['leftSecsPre',
        'leftSecsBegin',
        'leftSecsEnd'
      ])
    }
  }
</script>
